"use client";

import { useSyncExternalStore } from "react";

const noopSubscribe = () => () => {};

/**
 * Смещение пояса зрителя (как `Date#getTimezoneOffset()`: для МСК −180).
 * На сервере — null: пояс сервера не пояс зрителя, а разный текст ломает гидрацию.
 */
export function useViewerTzOffset(): number | null {
  return useSyncExternalStore(noopSubscribe, () => new Date().getTimezoneOffset(), () => null);
}

/** «UTC+3», «UTC−4:30» — подпись пояса у часов игры. */
export function formatUtcOffset(tzOffsetMin: number): string {
  const east = -tzOffsetMin;
  const sign = east >= 0 ? "+" : "−";
  const h = Math.floor(Math.abs(east) / 60);
  const m = Math.abs(east) % 60;
  return `UTC${sign}${h}${m ? `:${String(m).padStart(2, "0")}` : ""}`;
}
